.illustrations {
  padding: 72px 0;
  background: var(--color-primary-sand-100); /* PRIMARY_SAND_100 — sand band (overrides the base section--sand white) */
  border-top: 3px solid var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  border-bottom: 3px solid var(--color-primary-grey-900);
}

.illustrations__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.illustration {
  /* <figure> has a default UA margin (40px each side) which would shrink the card inside its
     grid track; the page's base reset only normalizes box-sizing (not margins, to avoid touching
     the reused header/footer), so zero it here. */
  margin: 0;
  background: var(--color-primary-grey-000);
  border: var(--plume-border-card, 2px solid var(--color-primary-grey-900));
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 0 0 0 rgba(35, 34, 33, 0);
  transition:
    transform 0.22s ease,
    box-shadow 0.22s ease;
  display: flex;
  flex-direction: column;
}

.illustration:hover {
  box-shadow: var(--plume-shadow-illustration-hover, 1px 2px 14px 0 rgba(89, 84, 78, 0.12));
  transform: var(--plume-hover-shift, translateY(-3px));
}

.illustration__img {
  aspect-ratio: 4 / 3;
  overflow: hidden;
  background: var(--color-primary-sand-100); /* PRIMARY_SAND_100 */
}

.illustration__img img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.illustration:hover .illustration__img img {
  transform: scale(1.06);
}

.illustration__foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 20px;
}

.illustration__caption {
  font-weight: 700;
  font-size: 15px;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  line-height: 1.25;
}

@media (max-width: 860px) {
  .illustrations__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 560px) {
  .illustrations__grid {
    grid-template-columns: 1fr;
  }
}
